
  var _styles = {
  "joined-popup-card": {
    "width": "7.52rem",
    "height": "6.82667rem",
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "joined-popup-subtitle": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.96rem",
    "fontWeight": "600",
    "textAlign": "center",
    "marginTop": "1.10667rem"
  },
  "joined-popup-description": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "textAlign": "center",
    "marginTop": "0.14667rem"
  },
  "joined-popup-invite-btn": {
    "width": "6.70667rem",
    "height": "1.2rem",
    "borderRadius": "7.45333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "joined-popup-invite-btn-text": {
    "color": "rgb(17,17,17)",
    "fontSize": "0.48rem",
    "lineHeight": "0.53333rem",
    "textAlign": "center"
  },
  "joined-popup-points-label": {
    "position": "absolute",
    "right": 0,
    "paddingTop": 0,
    "paddingRight": "0.17333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.17333rem",
    "top": "-0.26667rem",
    "height": "0.50667rem",
    "backgroundColor": "rgb(255,45,25)",
    "borderRadius": "0.33333rem 0.33333rem 0.33333rem 0.06667rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "joined-popup-points-label-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem"
  }
};



  module.exports = _styles;
  